import { Controller } from "@hotwired/stimulus"
import "emoji-picker-element"

export default class extends Controller {
  static targets = ["button", "input", "dropdown"]

  connect() {
    this.updateButton()

    // Listen for emoji selection from the web component
    this.dropdownTarget.querySelector("emoji-picker")
      .addEventListener("emoji-click", (e) => this.onEmojiClick(e))
  }

  toggle(event) {
    event.stopPropagation()
    this.dropdownTarget.classList.toggle("hidden")
  }

  onEmojiClick(event) {
    this.inputTarget.value = event.detail.unicode
    this.updateButton()
    this.dropdownTarget.classList.add("hidden")
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.dropdownTarget.classList.add("hidden")
    }
  }

  clear(event) {
    event.stopPropagation()
    this.inputTarget.value = ""
    this.updateButton()
  }

  updateButton() {
    const emoji = this.inputTarget.value.trim()
    this.buttonTarget.textContent = emoji || "＋"
    this.buttonTarget.classList.toggle("text-base-content/30", !emoji)
    this.buttonTarget.classList.toggle("text-2xl", !!emoji)
  }
}
